import { EMRdetailsProps, IEMRUpdatePayloadProps } from "@/api_framework/api_modals/EMRs";
import { useUpdateTempEMRAPI } from "@/app/hooks/api_hooks/emr/useUpdateTempEMRAPI";
import { debounce } from "lodash";
import { useCallback, useEffect, useMemo, useRef } from "react";
import { useForm } from "react-hook-form";

export interface MedicalInstructionsFromProps {
  body: string | null;
  paws: string | null;
  ears: string | null;
}
type SectionType = "body" | "paws" | "ears";

const SkinLesionComponent = ({ emrDetails }: EMRdetailsProps) => {
  const { execute: updateEmrAPI } = useUpdateTempEMRAPI();

  const params = new URLSearchParams(location.search);
  const emr_id = params.get("emr_id");

  const formHook = useForm<MedicalInstructionsFromProps>({
    mode: "onChange",
  });

  const debouncedUpdate = useMemo(
    () =>
      debounce((section: SectionType, value: string) => {
        const constructedBody: IEMRUpdatePayloadProps = {
          [section]: value,
          emr_status: emrDetails?.emr_status,
        };
        updateEmrAPI(emr_id, constructedBody);
      }, 1000),
    [],
  );
  const isFirstLoad = useRef(true);

  const handleInputChange = useCallback(
    (section: SectionType) => {
      const value = formHook.getValues(section);
      debouncedUpdate(section, value);
    },
    [formHook, debouncedUpdate],
  );

  useEffect(() => {
    if (emrDetails) {
      isFirstLoad.current = false; // disable auto-save
      formHook.reset({
        body: emrDetails?.body || "",
        ears: emrDetails?.ears || "",
        paws: emrDetails?.paws || "",
      });
      // enable watch only after state settled
      setTimeout(() => {
        isFirstLoad.current = true;
      }, 0);
    }
  }, [emrDetails]);

  return (
    <div className=" w-full py-3 bg-[#F9FAFB] p-3 rounded-[10px] mt-3">
      <h3 className="text-[#000000] text-sm font-medium tracking-tight42 ">Skin Lesions</h3>
      <div className=" w-full  flex flex-col gap-3  mt-2 ">
        <div className="bg-white rounded-xl p-[10px]">
          <h3 className="text-[#000000] text-sm font-medium tracking-tight42">Ears</h3>
          <div className="bg-[#FFFFFF] rounded-xl mt-1.5  ">
            <textarea
              className="w-full   border border-[#E2E2E2] rounded-xl p-3 text-sm text-[#6C727F] focus:outline-none"
              placeholder="Write if anything requires..."
              {...formHook.register("ears", {
                required: false,
                onChange: () => handleInputChange("ears"),
              })}
            ></textarea>
          </div>
        </div>
        <div className="bg-white rounded-xl p-[10px]">
          <h3 className="text-[#000000] text-sm font-medium tracking-tight42">Paws</h3>
          <div className="bg-[#FFFFFF] rounded-xl mt-1.5  ">
            <textarea
              className="w-full   border border-[#E2E2E2] rounded-xl p-3 text-sm text-[#6C727F] focus:outline-none"
              placeholder="Write if anything requires..."
              {...formHook.register("paws", {
                required: false,
                onChange: () => handleInputChange("paws"),
              })}
            ></textarea>
          </div>
        </div>
        <div className="bg-white rounded-xl p-[10px]">
          <h3 className="text-[#000000] text-sm font-medium tracking-tight42">Body</h3>
          <div className="bg-[#FFFFFF] rounded-xl  mt-1.5 ">
            <textarea
              className="w-full   border border-[#E2E2E2] rounded-xl p-3 text-sm text-[#6C727F] focus:outline-none"
              placeholder="Write if anything requires..."
              {...formHook.register("body", {
                required: false,
                onChange: () => handleInputChange("body"),
              })}
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SkinLesionComponent;
